<template>
  <footer class="oen-ui-card-footer">
    <!-- @slot for the card footer, handles `<OenUiButton>` -->
    <slot />
  </footer>
</template>

<style scoped>
.oen-ui-card-footer {
  @apply bg-white;
  @apply flex flex-row-reverse justify-between;
  @apply shadow-inset-1;
  @screen sm {
    @apply px-12;
    @apply bg-transparent;
    @apply shadow-none;
  }
  :deep(> *:first-child) {
    @apply order-1;
  }
  :deep(.oen-ui-button),
  :deep(.oen-ui-menu) {
    @apply w-full;
    @screen sm {
      @apply w-auto;
    }
  }
  :deep(.oen-ui-button) {
    @apply rounded-none;
    @apply border-none;
    @screen sm {
      @apply rounded-xxl;
      @apply border-solid;
    }
  }
}
</style>
